import React from "react";
import subbanner from "../assets/images/sub-banner.jpg";
import { useTranslation } from "react-i18next";
// Define prop types
interface SubbannerProps {
  height?: string;
  className?: string;
}

const Subbanner: React.FC<SubbannerProps> = ({
  height = "80vh",
  className = "",
}) => {
   const { t } = useTranslation();
  return (
    <div className={`relative w-full ${className}`} style={{ height }}>
      {/* Banner Image */}
      <img src={subbanner} alt="Banner" className="w-full h-full object-cover" />

      {/* Centered Text */}
      <div className="absolute inset-0 flex items-center justify-center">
        <h1 className="text-white text-4xl font-bold drop-shadow-lg pt-[7rem]">{t("casualGames")}</h1>
      </div>
    </div>
  );
};

export default Subbanner;
